import { Fragment, useState, useEffect, useRef, useCallback } from 'react';
import { Button, Layout, Modal, Tree, message, Dropdown, Space } from 'antd';
import AddDepartmentList from './AddDepartmentList';
import DepartmentSortDrawer from './DepartmentSortDrawer';
import { TreeDataSource as TreeDataSource1 } from '@utils/utils';
import { get, put, post, delte } from '@/core/request';
import './DepartmentList.less';
import PageHeader from '@components/PageHeader/PageHeader';
export default function DepartmentList() {
    // 新增modal相关
    const [isModalVisible, setIsModalVisible] = useState(false);
    // 渲染分类的树状结构
    const [departmentTree, setDepartmentTree] = useState([]);
    const [oldDepartmentTree, setOldDepartmentTree] = useState([]);

    // 点击删除
    const deleteConfirm = element => {
        Modal.confirm({
            title: '提示',
            icon: <i className="bi bi-exclamation-circle"></i>,
            content: '确认删除？',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                const form = new FormData();
                form.append('id', element.id);
                delte('/enterprise/departments/delete', form).then(res => {
                    if (res.status_code === 200) {
                        message.success(res.message);
                        getData();
                    }
                });
            },
        });
    };

    const [saveKey, setSaveKey] = useState([]);
    const [openKey, setOpenKey] = useState([]);

    // 默认展开和默认关闭
    const handleOpenKeys = tip => {
        return () => {
            if (tip === 'open') {
                setOpenKey(saveKey);
            } else {
                setOpenKey([]);
            }
        };
    };

    const handleExpand = expandedKeys => {
        setOpenKey(expandedKeys);
    };

    const [modalData, setModalData] = useState({
        tip: '',
        row: {},
    });

    const showModal = (tip, elem) => {
        return () => {
            setModalData({
                tip,
                row: elem,
            });
            setIsModalVisible(true);
        };
    };

    // 点击添加子部门和删除
    const handleMenuClick = elem => {
        return e => {
            if (e.key === 'addChild') {
                setIsModalVisible(true);
                setModalData({
                    tip: 'addChild',
                    row: elem,
                });
            } else if (e.key === 'delete') {
                if (elem.children) return message.error('该部门存在子部门或员工，禁止删除！');
                deleteConfirm(elem);
            }
        };
    };

    const handleMouseEnter = e => {
        if (e.target.className === 'edit') {
            e.target.classList.add('mystyle');
        }
    };

    const handleMouseLeave = e => {
        e.target.classList.remove('mystyle');
    };

    const handleMouseLeaveInner = e => {
        e.currentTarget.parentNode.classList.remove('mystyle');
    };

    const rendertitle = (left, element) => {
        const departmentMenu = {
            items: [
                { key: 'addChild', label: '添加子部门' },
                { key: 'delete', label: '删除', danger: true },
                { key: 'show', label: `部门Id:${element.id}`, disabled: true },
            ],
            onClick: handleMenuClick(element),
        };
        return (
            <div className="edit" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                {element.name}
                {/* <span className='department-num'>[{element.nums}人]</span> */}
                <div className="tree-edit" style={{ left }} onMouseLeave={handleMouseLeaveInner}>
                    <Space.Compact>
                        <Button size="small" onClick={showModal('edit', element)}>
                            编辑
                        </Button>
                        <Dropdown menu={departmentMenu} trigger={['click']}>
                            <Button size="small" icon={<i className="bi bi-chevron-down"></i>} />
                        </Dropdown>
                    </Space.Compact>
                </div>
            </div>
        );
    };

    // 递归遍历数组 修改元素
    const TreeDataSource = arr => {
        if (!Array.isArray(arr)) {
            return;
        }
        return arr.map(item => {
            saveKey.push(item.id);
            return {
                ...item,
                title: rendertitle('320px', item),
                key: item.id,
                children: item.childList?.length && TreeDataSource(item.childList),
            };
        });
    };

    const [arr, setArr] = useState([]);
    const getData = () => {
        let arr = [];
        get(`/enterprise/departments/get_all`).then(res => {
            if (res.status_code === 200) {
                arr = TreeDataSource(res.data);
                setArr(TreeDataSource1(res.data));
                setOpenKey(saveKey);
                setOldDepartmentTree(TreeDataSource1(res.data));
                setDepartmentTree(arr);
            }
        });
    };

    // 渲染treeList数据
    useEffect(() => {
        getData();
    }, []);

    // 新增部门
    const handleAddDepartment = useCallback(value => {
        post(`/enterprise/departments/save`, value).then(res => {
            if (res.status_code === 200) {
                message.success(res.message);
                getData();
            }
        });
    }, []);

    // 编辑/添加子部门
    const handleEditDepartment = useCallback(value => {
        put(`/enterprise/departments/update`, value).then(res => {
            if (res.status_code === 200) {
                message.success(res.message);
                getData();
            }
        });
    }, []);

    const drawer = useRef();
    // 部门排序
    const handleSortDepartment = () => {
        drawer.current.show();
    };

    return (
        <Fragment>
            <PageHeader title="部门管理" breadcrumb={[]} />

            <div className="page-route-body">
                <div className="table-region-container enterprise-department-table-region">
                    <div className="main-toolbar enterprise-department-toolbar">
                        <div className="main-tools">
                            <Space>
                                <Button type="primary" onClick={showModal('add')}>
                                    新增部门
                                </Button>
                                <Button onClick={handleSortDepartment}>部门排序</Button>
                                <Button onClick={handleOpenKeys('open')}>全部展开</Button>
                                <Button onClick={handleOpenKeys('close')}>全部收起</Button>
                            </Space>
                        </div>
                    </div>

                    <div className="enterprise-department-tree-wrap">{departmentTree.length > 0 && <Tree blockNode expandedKeys={openKey} treeData={departmentTree} onExpand={handleExpand} />}</div>
                </div>
            </div>

            {/* 点击新增的modal */}
            {isModalVisible && (
                <Modal open={isModalVisible} closable={false} footer={null}>
                    <AddDepartmentList modalData={modalData} oldDepartmentTree={oldDepartmentTree} handleAddDepartment={handleAddDepartment} setIsModalVisible={setIsModalVisible} handleEditDepartment={handleEditDepartment}></AddDepartmentList>
                </Modal>
            )}

            {/* 部门排序drawer */}
            <DepartmentSortDrawer ref={drawer} oldDepartmentTree={oldDepartmentTree} arr={arr} getData={getData}></DepartmentSortDrawer>
        </Fragment>
    );
}
